import React, { useContext } from "react";
import { PayPalButtons, usePayPalScriptReducer } from "@paypal/react-paypal-js";
import axios from "axios";
import { toast } from "react-toastify";
import { directoryContext } from "../context/Context";

export const Paypal = ({ currency, setShowSuccess }) => {
  const [{ options, isPending }, dispatch] = usePayPalScriptReducer();
  const style = { layout: "vertical" };
  const {
    userState: { user },
    userDispatch,
  } = useContext(directoryContext);

  const updatePayment = async (id) => {
    try {
      const response = await axios.post(
        `https://www.api.webdirectories.info/api/auth/payment/${id}`,
        {
          status: "Paid",
        }
      );

      if (response.status === 200) {
        userDispatch({ type: "UPDATE_USER", payload: response?.data?.auth });
      }
    } catch (error) {
      console.log(error);
    }
  };

  const createOrder = async (data) => {
    try {
      await updatePayment(data.user);
      const res = await axios.post(
        "https://www.api.webdirectories.info/api/transaction/add",
        data
      );
      if (res.status === 201) {
        toast.success("Payment Successful! ");
        setShowSuccess(true);

        return res.data;
      }
    } catch (err) {
      console.log(err);
    }
  };

  React.useEffect(() => {
    dispatch({
      type: "resetOptions",
      value: {
        ...options,
        currency: "USD",
      },
    });
  }, [currency]);

  return (
    <>
      {isPending && <div className="spinner" />}
      <PayPalButtons
        style={style}
        disabled={false}
        forceReRender={[179, currency, style]}
        fundingSource={undefined}
        createOrder={(data, actions) => {
          return actions.order
            .create({
              purchase_units: [
                {
                  amount: {
                    currency_code: currency,
                    value: 179,
                  },
                },
              ],
            })
            .then((orderId) => {
              // Your code here after create the order
              console.log(orderId);
              return orderId;
            });
        }}
        onApprove={function (data, actions) {
          return actions.order.capture().then(function (details) {
            // const shipping = details.purchase_units[0].shipping;
            createOrder({
              user: user?._id,
              amount: details.purchase_units[0].amount.value,
              transactionId: details.id,
              payer: details.payer,
            });
          });
        }}
      />
    </>
  );
};
